import { useEffect, useState } from 'react';
import { Box, Button, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { MonthlyInvestmentEmailPreferenceDTO } from '@inversor-hub/types';
import {
  useGetMonthlyInvestmentEmailPreference,
  useUpdateMonthlyInvestmentEmailPreference,
} from '@/lib/api/me.ts';
import { enqueueSnackbar } from 'notistack';
import { StackedSnackbar } from '@/components/ui/StackedSnackbar.tsx';

export default function MonthlyInvestmentEmailPreferences() {
  const { data, isLoading } = useGetMonthlyInvestmentEmailPreference();
  const { mutate: updatePreference, isPending } = useUpdateMonthlyInvestmentEmailPreference();
  const [formData, setFormData] = useState<MonthlyInvestmentEmailPreferenceDTO>({
    enabled: true,
  });
  const [error, setError] = useState('');

  useEffect(() => {
    if (data) {
      setFormData(data);
    }
  }, [data]);

  const handleSave = () => {
    setError('');
    updatePreference(formData, {
      onSuccess: () => {
        enqueueSnackbar(<StackedSnackbar title="Preferencia de email mensual actualizada" />, {
          variant: 'success',
        });
      },
      onError: () => setError('Error al guardar la preferencia'),
    });
  };

  if (isLoading) {
    return <Typography>Cargando emails mensuales...</Typography>;
  }

  return (
    <Box>
      <Typography variant="h6" fontWeight={600} mb={2}>
        Email mensual de inversión
      </Typography>
      <Stack spacing={2}>
        <Typography color="text.secondary">
          Enviamos un resumen el día 5 de cada mes. Si no hay movimientos registrados, te lo
          indicaremos en el propio email.
        </Typography>

        <FormControlLabel
          control={
            <Switch
              checked={formData.enabled}
              onChange={(event) =>
                setFormData((prev) => ({ ...prev, enabled: event.target.checked }))
              }
            />
          }
          label="Recibir email mensual"
        />

        <Box display="flex" gap={2} alignItems="center">
          <Button variant="contained" onClick={handleSave} disabled={isPending}>
            Guardar preferencia
          </Button>
          {error && <Typography color="error.main">{error}</Typography>}
        </Box>
      </Stack>
    </Box>
  );
}
